import React from 'react';
import { safeHTML } from '../../../../../../utils/safeHTML';

export default function Item({ userUid, title, image }) {
  return (
    <div className={`drawing-result-modal__item`}>
      <div className={`drawing-result-modal__item-image`}>
        <img src={image} className={`drawing-result-modal__item-image-img`} />
      </div>
      <div className={'drawing-result-modal__item-block'}>
        {userUid && <h4 className={'drawing-result-modal__item-name'}>{safeHTML(`id${userUid}`)}</h4>}
        {title && <p className={'drawing-result-modal__item-text'}>{safeHTML(title)}</p>}
      </div>
    </div>
  );
}
